/* eslint-disable react-hooks/rules-of-hooks */
import * as React from "react";
import { Stepper, Step, StepLabel, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Check from "@mui/icons-material/Check";
import { useState, useEffect } from "react";
import ModernAlertDialog from "../../frete/components/ModernAlertDialog";

// Cores
const ORANGE_FORTIO = "#FF3100";
const COR_TEXTO = "#012443";
const COR_INATIVA = "#E0E0E0";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.vertical}`]: {
    display: "none",
  },
  [`&.${stepConnectorClasses.horizontal}`]: {
    top: 20,
    left: "calc(-50% + 20px)",
    right: "calc(50% + 20px)",
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 8,
    border: 0,
    backgroundColor: COR_TEXTO,
    borderRadius: 4,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: COR_TEXTO,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: COR_TEXTO,
  },
}));

const CustomStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: COR_INATIVA,
  zIndex: 1,
  color: COR_TEXTO,
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "1.1rem",
  fontWeight: "bold",
  boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  ...(ownerState.active && {
    backgroundColor: ORANGE_FORTIO,
    color: "#fff",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundColor: ORANGE_FORTIO,
    color: "#fff",
  }),
}));

function CustomStepIcon(props) {
  const { active, completed, className, icon } = props;

  return (
    <CustomStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {completed ? <Check sx={{ fontSize: "1.5rem" }} /> : <span>{icon}</span>}
    </CustomStepIconRoot>
  );
}

const steps = [
  "Em Aberto",
  "Enviado",
  "Aprovado",
  "Cancelado",
];

const codeToIndex = {
  "01": 0,
  "02": 1,
  "03": 2,
  "04": 3,
};

const getIndexFromStatus = (value) => {
  if (value == null) return 0;
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    if (codeToIndex[value] != null) return codeToIndex[value];
    const byLabel = steps.findIndex((step) => step === value);
    return byLabel >= 0 ? byLabel : 0;
  }
  return 0;
};

export default function ProgressStepsBudget({ propsStatus, onStatusConfirm }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [activeStep, setActiveStep] = useState(getIndexFromStatus(propsStatus));
  const [selectedIndex, setSelectedIndex] = useState(getIndexFromStatus(propsStatus));
  const [open, setOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "Confirmar Ação",
    message: "Você deseja confirmar esta etapa?",
  });

  useEffect(() => {
    setActiveStep(getIndexFromStatus(propsStatus));
  }, [propsStatus]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleStepClick = (index) => {
    const nextLabel = steps[index];
    if (nextLabel !== "Aprovado" && nextLabel !== "Cancelado") {
      return;
    }

    setSelectedIndex(index);

    if (nextLabel === "Cancelado") {
      setModalConfig({
        title: "Confirmar Ação",
        message: "Você deseja realmente cancelar o Orçamento?",
      });
    } else {
      setModalConfig({
        title: "Confirmar Ação",
        message: "Você deseja realmente aprovar este Orçamento?",
      });
    }

    handleOpen();
  };

  const handleConfirm = async () => {
    const nextLabel = steps[selectedIndex];
    if (typeof onStatusConfirm === "function") {
      const result = await onStatusConfirm(nextLabel, selectedIndex);
      if (result === false) {
        return;
      }
    }

    setActiveStep(selectedIndex);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <Stepper
        activeStep={activeStep}
        orientation={isMobile ? "vertical" : "horizontal"}
        alternativeLabel={!isMobile}
        connector={<CustomConnector />}
        sx={{
          ...(isMobile && {
            "& .MuiStep-root": {
              marginBottom: "16px",
            },
          }),
          "& .MuiStepLabel-label": {
            color: COR_TEXTO,
            fontWeight: 500,
            marginTop: "8px",
            "&.Mui-active": {
              color: COR_TEXTO,
              fontWeight: 700,
            },
            "&.Mui-completed": {
              color: COR_TEXTO,
              fontWeight: 500,
            },
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={CustomStepIcon}
              onClick={() => handleStepClick(index)}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <ModernAlertDialog
        open={open}
        handleClose={handleClose}
        title={modalConfig.title}
        msg={modalConfig.message}
        confirmLabel="Sim"
        cancelLabel="Não"
        showCancel
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
}

